import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { gqlGetNotifications } from '../graphql';
import { buildWhereFromFilterValues } from './filters';
import { useState } from 'react';
import { notificationStatusLabel, notificationTypeLabel } from '../constants';

export const exportColumns = (t) => {
  return [
    { fieldName: 'id', fieldTitle: t('ID'), fieldType: 'TEXT' },
    { fieldName: 'name', fieldTitle: t('Όνομα'), fieldType: 'TEXT' },
    { fieldName: 'typeLabel', fieldTitle: t('Τύπος'), fieldType: 'TEXT' },
    { fieldName: 'statusLabel', fieldTitle: t('Κατάσταση'), fieldType: 'TEXT' },
    { fieldName: 'tokenTtlDays', fieldTitle: t('Ημέρες token'), fieldType: 'INT' },
    { fieldName: 'isActiveText', fieldTitle: t('Ενεργή'), fieldType: 'TEXT' },
    { fieldName: 'firstDate', fieldTitle: t('Ημερ. Δημιουργίας'), fieldType: 'DATE' },
  ];
};

export async function handleExport(client, queryState: any, t): Promise<void> {
  function useGetQuery() {
    const [get, { loading }] = useLazyQuery(gqlGetNotifications, {
      onCompleted: transformData,
      fetchPolicy: 'network-only',
    });

    const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

    function transformData(data) {
      const recs = data.getNotifications.data.map((v) => ({
        ...v,
        typeLabel: notificationTypeLabel(v.typeCode),
        statusLabel: notificationStatusLabel(v.statusId),
        isActiveText: v.isActive ? 'ΝΑΙ' : 'ΟΧΙ',
      }));

      setResult([
        get,
        {
          loading,
          data: {
            getNotifications: {
              data: recs,
              recordCount: data?.getNotifications?.recordCount,
            },
          },
        },
      ]);
    }

    return result;
  }

  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues),
  };

  await exportXlsModal({
    apolloClient: client,
    exportFileName: t('Εξαγωγή Ενημερώσεων'),
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables: filterVariables,
  });
}
